

import CBridge from '@entcor/ebridge'

// eslint-disable-next-line import/no-mutable-exports
let $_bridge
let mapUrl

export const isDevMode =
  process.env.VUE_APP_DEVELOP === 'true' || process.env.VUE_APP_DEVELOP === true

export const $_localhost = Boolean(
  window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/,
    ),
)

// apiId: maps|scipter|bridge
export function getURL(apiId, path) {
  // const devServer = 'http://192.168.50.69'
  const devServer = ''
  // const httpsDevServer = 'https://192.168.50.69'
  const httpsDevServer = ''
  const prefix = $_localhost ? `${devServer}` : ''
  let res = ''

  switch (apiId) {
    case 'maps':
      res = mapUrl || `${prefix}/tile`
      break
    case 'scripter':
      res = `${prefix}/`
      break
    case 'bridge':
      res = prefix
      break
    case 'devServer':
      res = devServer
      break
    case 'httpsDevServer':
      res = httpsDevServer
      break
    case 'i18n':
      res = `${prefix}/e-cmdb/api/i18n`
      break
    default:
  }

  return (path ? res + path : res).replace(new RegExp('(?<!:)\\/\\/', 'g'), '/')
}

async function initBridge() {
  const serverUrl = getURL('bridge')
  // console.log('process.env.VUE_APP_DEVELOP', process.env.VUE_APP_DEVELOP)
  // console.log('process.env.PORT', process)
  $_bridge = new CBridge({
    url: serverUrl,
    alarms: true,
    metaDownload: true,
    useBrowserCache: true,
  })

  // localStorage.setItem('testToken', ...)
  // let token = localStorage.getItem('token')
  // console.log('lastToken', token)

  // let testIsLogged = await $_bridge.isLogged()
  // console.log('$_bridge.isLogged', testIsLogged)

  if (await $_bridge.isLogged()) {
    await $_bridge.connect()
  }

  $_bridge.on('connect', async () => {
    try {
      const $server = await $_bridge.getByPath('/config/server')
      console.log('TESTMAPSERVER', $server)
      mapUrl = $server?.config?.OSM?.url
    } catch (ex) {
      console.error(ex)
    }
  })

  return $_bridge
}

function connect(user, password) {
  return $_bridge.connect($env, {
    user,
    password,
  })
}

export { initBridge, connect, $_bridge }
